import axios from 'axios';

export default async function (options) {
  options.data = options.data || {};

  options.timeout = options.timeout || 3000;

  options.method = options.method || 'get';
  if (options.method.toLowerCase() == 'get' || options.method.toLowerCase() == 'delete') {
    options.params = Object.assign({}, options.data);
  }

  let data;
  try {
    const tmp = await axios(options);
    if (!options._all) {
      data = tmp?.data || {};
    } else {
      data = tmp;
    }
  } catch (e) {
    console.log('axios error', options, e);
    data = '';
  }

  return data;
}
